import {Component, OnInit} from '@angular/core';
import {ApiService} from '../../../../../projects/accounting/src/public_api';
import {ASCIIPipe} from "../../../.../../../../projects/jv-common/src/public_api";
import {BsModalService} from "ngx-bootstrap";
import {ConfirmPopupComponent} from "../confirm-popup/confirm-popup.component";
import {Router} from "@angular/router";
declare var $: any;
@Component({
    selector: 'app-transfer',
    templateUrl: './transfer.component.html',
    styleUrls: ['./transfer.component.scss']
})
export class TransferComponent implements OnInit {
    private InventoryID = 168;
    configs = {
        displayKey: "Name",
        search: true,
        height: 'auto',
        placeholder: 'Chọn nhà cung cấp',
        noResultsFound: 'Không có kết quả nào!',
        searchPlaceholder: 'Tìm kiếm',
        searchOnKey: 'KeyData',
    };

    loading = false;

    data = null;

    selectedVendor = null;
    selectedTemp = null;

    txt = '';

    productTemps = [];
    products = [];
    orderItems = [];

    constructor(
        private api: ApiService,
        private ascii: ASCIIPipe,
        private bsModalService: BsModalService,
        private router: Router
    ) {

    }

    ngOnInit() {
        this.load();
    }

    async load() {
        this.loading = true;
        this.api.pomPublicIOPull(this.InventoryID).subscribe((rs: any) => {
            rs.data.Vendors.forEach(i => {
                i.KeyData = this.ascii.transform([i.Phone, i.Name, i.Address].join(' ')) + [i.Phone, i.Name, i.Address].join(' ');
            });
            rs.data.ProductsLU = {};
            rs.data.UnitsLU = {};
            rs.data.Products.forEach(i => {
                rs.data.ProductsLU[i.ID] = i;
            });
            rs.data.Units.forEach(i => {
                rs.data.UnitsLU[i.ID] = i;
            });
            this.data = rs.data;
            this.loading = false;
        })
    }

    async getTransferInfo() {
        this.loading = true;
        this.productTemps = [];
        this.products = [];
        let data = {
            WarehouseID: this.InventoryID,
            PartnerID: this.selectedVendor.ID,
            PartnerType: 'voc',
            TransferType: 'import'
        };
        this.api.pomTransferInfo(data).subscribe((rs: any) => {
            this.loading = false;
            if (rs.succeed) {
                let transferInfo = {};
                rs.data.forEach(i => {
                    transferInfo[i.ProductID] = i;
                });
                let products = [];
                this.selectedVendor.Products.map(i => {
                    if (typeof this.data.ProductsLU[i] != "undefined" && typeof transferInfo[i] != 'undefined' && typeof this.data.UnitsLU[transferInfo[i].UnitID] != "undefined") {
                        products.push({
                            ...this.data.ProductsLU[i],
                            info: transferInfo[i],
                            UnitName: this.data.UnitsLU[transferInfo[i].UnitID].Name,
                        })
                    }
                });
                this.products = products;
                this.productTemps = products;
            }
        })
    }

    changeVendor(e) {
        this.selectedVendor = e.value;
        this.getTransferInfo();
    }

    back() {
        this.selectedVendor = null;
    }

    filter() {
        let txt = this.ascii.transform(this.txt).toLowerCase();
        this.productTemps = this.products.filter(i => this.ascii.transform(i.Name).toLowerCase().indexOf(txt) > -1);
    }

    addProduct(i) {
        let tester = this.orderItems.filter(ii => ii.ID == i.ID);
        if (tester.length > 0) {
            tester[0].Quantity += (i.info.Factor == 0 ? 1 : i.info.Factor);
        } else {
            this.orderItems.push({
                ...i,
                Quantity: i.info.Factor == 0 ? 1 : i.info.Factor,
                IsEditing: false
            })
        }
    }

    enableEditing(i) {
        i.IsEditing = true;
    }

    endEdit(i) {
        i.IsEditing = false;
    }

    update(i) {
        i.IsEditing = false;
        i.Quantity = parseFloat($('.quantity-' + i.ID).val());
        i.info.Price = parseFloat($('.price-' + i.ID).val());
    }

    delete(i) {
        this.orderItems = this.orderItems.filter( ii => ii.ID != i.ID);
    }
    openConfirm(){
        if (this.orderItems.length == 0){
            return;
        }
        this.bsModalService.show(ConfirmPopupComponent, {
            class: 'modal-md',
            initialState: {
                data: {
                    orderItems: this.orderItems,
                    vendor: this.selectedVendor,

                }
            }
        }).content.send.subscribe(rs => {
            this.import(rs);
        })
    }
    import(PaidAmount) {
        this.loading = true;
        let body = {
            InventoryID: this.InventoryID,
            PartnerID: this.selectedVendor.ID,
            PartnerType: 'voc',
            Action: 'import',
            Details: [],
            PaidAmount,
            Confirmable: false
        };
        this.orderItems.forEach( i => {
            body.Details.push({
                ProductID: i.ID,
                UnitID: i.info.UnitID,
                Quantity: i.Quantity,
                Total: i.Quantity * i.info.Price,
            })
        });
        this.api.pomWarehousesTransfer(body).subscribe( rs => {
            this.loading = false;
            if (rs){
                this.router.navigateByUrl('controllers/pending-ies')
            }else{
                alert('Lỗi không nhập được hàng');
            }
        }, err => {
            this.loading = false;
            console.log(err);
            alert('Lỗi không nhập được hàng');
        })
    }

}
